module.exports = __webpack_public_path__ + "static/img/医生头像.6d9387a0.png";